import React, { useRef, useState } from 'react'
import { Box, Dialog, makeStyles } from '@material-ui/core'

import { TableMenuButton, DraggablePaper } from 'civic-champs-shared'
import { ReactComponent as FilterIcon } from 'images/filter.svg'
import GroupOverviewFilterModal from './GroupOverviewFilterModal'

export interface GroupOverviewFilterButtonProps {
  showArchivedGroups: boolean
  setShowArchivedGroups: (value: boolean) => void
}

const useStyles = makeStyles({
  button: {
    padding: '8px 10px 8px 16px',
  },
})

//TODO copied from src/core/table/components/NewFilters.tsx
//
//   For now this copy pasta is faster than rewriting the FiltersModal to
//   to unify getOperations and binaryOperations
//
export const GroupOverviewFilterButton = (props: GroupOverviewFilterButtonProps) => {
  const classes = useStyles()

  const anchorEl = useRef(null)
  const [modalVisible, setModalVisible] = useState(false)

  return (
    <>
      {/*
    // @ts-ignore */}
      <Box ref={anchorEl}>
        <TableMenuButton className={classes.button} startIcon={<FilterIcon />} onClick={() => setModalVisible(true)}>
          Add Filter
        </TableMenuButton>
        <Dialog
          open={modalVisible}
          onClose={() => setModalVisible(false)}
          PaperComponent={DraggablePaper}
          PaperProps={{
            // @ts-ignore
            handle: `#filter-title`,
          }}
          aria-labelledby="filter-title"
          maxWidth="lg"
          disableEnforceFocus
        >
          <GroupOverviewFilterModal {...props} onClose={() => setModalVisible(false)} />
        </Dialog>
      </Box>
    </>
  )
}
